export default __webpack_public_path__ + "static/media/aviation-industry-page.e1539890.jpg";